















































































helpers = require('../../helpers.coffee')

view_model = {
  components:
    actionList: require '../flow_actions/list'
    contacts: require './contacts'
    taskModalForm: require('../manual_tasks/modal_form')
    ModalFlowForm: require('../manual_tasks/modal_flow')

  data: ->
    current_user: Session.current_user
    flow: new Flow weekdays_to_send: [], email_statistic: {}, actions: []
    actions: []
    confirming_destroy_flow: false

  methods:
    openTaskModalForm: ->
      EventsBus.$emit 'ModalFlowForm::Show', { task_id: null, contact: @contact, id: 'dialer-manual-flow-form-modal' }
    toggleTaskBar: (data) ->
      EventsBus.$emit 'toggle-task-bar', data.contact.id

    trackEventViewContact: (flow) ->
      viewContactFlow = this.$t('flows.label.viewContactFlow')
      viewContactFlowDescription = this.$t('flows.label.viewContactFlowDescription')
      IntercomCtrl.trackEvent(viewContactFlow, { viewContactFlowDescription: @flow.id })

    setFlow: (flow) ->
      @flow = flow
      @actions = flow.actions
      Tooltip.initialize()

    toggleFlowStatus: ->
      return unless !@current_user.isMonitoringManager()
      statusChangeLabel = this.$t('flows.label.statusChangeLabel', { name: @flow.name, human_status: @flow.human_status })
      statusChangeDescriptionLabel = this.$t('flows.label.statusChangeDescription')
      @flow.toggleStatus()
      IntercomCtrl.trackEvent(statusChangeLabel, { statusChangeDescriptionLabel: @flow.id })
      @flow_resource.update @updateFlowSuccess, null, { id: @flow.id, status: @flow.status }

    updateFlowSuccess: (resources) ->
      @setFlow resources.flow
      alertify.success this.$t('flows.label.updateFlowSuccess', { status: @flow.human_status })

    loadFlow: ->
      Loader.on()
      @flow_resource.get @loadFlowSuccess, @unknownError, id: @$route.params.id

    loadFlowSuccess: (resources) ->
      @setFlow resources.flow
      Loader.off()
      @redirectIfNotOwner(@flow)

    confirmDestroy: ->
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-destroy-flow-modal'

    reengageContacts: ->
      @flow_resource.reengage @flowReengageSuccess, null, { id: @flow.id }

    flowReengageSuccess: ->
      alertify.success this.$t('flows.label.contactResume')
      EventsBus.$emit 'reload-contacts'

    destroyConfirmed: ->
      intercomTitle = this.$t('flows.label.removeDialogTitle')
      intercomDescription = this.$t('flows.label.removeDialogDescription')
      viewContactFlowDescription = this.$t('flows.label.viewContactFlowDescription')
      IntercomCtrl.trackEvent(intercomTitle, {
        intercomDescription: location.href,
        viewContactFlowDescription: @flow.id
        })
      @flow_resource.destroy @flowDestroySuccess, @flowDestroyFailure, id: @flow.id

    flowDestroySuccess: ->
      alertify.success this.$t('flows.feedback.removeSuccess')
      @$router.replace(name: 'flows')

    flowDestroyFailure: ->
      alertify.error this.$t('general.feedback.actionNotAllowed')

    editFlow: ->
      @$router.push path: @flowEditPath()

    flowEditPath: ->
      "/fluxos-de-cadencia/#{@flow.id}/editar"

    countLabelTooltipHtml: (data) ->
      lines = []
      for item in data
        lines.push "<p>
                      <span class='tooltip-count'>#{item[0]}</span>
                      <span class='tooltip-label'> #{item[1]} </span>
                    </p>"

      inner_html = lines.join('')

  computed:
    recipientsByStatusHtml: ->
      data = for _, status of @flow.recipients_statistics.by_status
        [status.count, status.human_label]
      @countLabelTooltipHtml(data)

    detailedConversionStatisticHtml: ->
      statistics = @flow.recipients_statistics
      return unless statistics?.by_stage?.lost && statistics?.by_status?.connected && statistics?.by_stage?.client
      data = [
        [statistics.by_status.not_connected?.count || 0, statistics.by_status.not_connected?.human_label || '-'],
        [statistics.by_status.disqualified?.count || 0, statistics.by_status.disqualified?.human_label || '-'],
        [statistics.by_status.blocklisted?.count || 0, statistics.by_status.blocklisted?.human_label || '-'],
        [statistics.by_status.connected.count, statistics.by_status.connected.human_label],
        [statistics.by_stage.client.count, statistics.by_stage.client.human_label + 's']
      ]
      @countLabelTooltipHtml(data)

    detailedReplyStatisticHtml: ->
      return unless @flow.email_statistic
      data = [
        [@flow.email_statistic.sent, @flow.email_statistic.humanLabel('sent')],
        [@flow.email_statistic.reply, @flow.email_statistic.humanLabel('reply')]
      ]
      @countLabelTooltipHtml(data)

    contactsCount: ->
      return 0 unless @flow.recipients_statistics.total
      @flow.recipients_statistics.total.count

    recipientsStatisticsConversion: ->
      return '--' unless @flow.recipients_statistics.by_stage
      percentage = (@flow.recipients_statistics.by_stage.conversion.value * 100.0).toFixed(1)
      percentage.replace('.', ',') + '%'

  created: ->
    @setFiltersFromQueryParams()
    @flow_resource = new FlowsResource Session.current_company.id
    @loadFlow()

  mounted: ->
    Tooltip.initialize()
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/show.vue